
// imports

	// models
	import searchModel from './searchModel.js';

	// vendor
	import URI from 'urijs';

	// view
	import { spinner } from './../modules/spinner';
	import { SearchMap } from './SearchMap.js';

	// view helpers
	import scrollTo from './../helpers/scrollTo';
	import debounce from './../helpers/debounce';

	// templates
	import templateResultsHeader from './../../../views/search-results-header.html';
	import templateResultsList from './../../../views/search-results-list.html';
	import templatePagination from './../../../views/search-pagination.html';

	// init modules
	spinner.init();


// dom elements

	const $form = $('.js-search-form');


// form fields 

	const $keywords = $('.js-search__keywords');
	const $location = $('.js-search__location');
	const $discipline = $('.js-search__discipline');
	const $contractType = $('.js-search__contractType');


// map setup

	const $container = $('.js-search-map');
	const $mapElement = $('.js-search-map__inner');
	const searchMap = new SearchMap($container, $mapElement);


// setup events and initial state

	function init() {

		// only start on search page
		if (!$form.length) return false;


		// form field updates

			const fields = searchModel.Fields.get();

			$form.on('submit', function() {
				// prevent http submit if fired by form
				if (event && event.type === 'submit') event.preventDefault();
				onFieldChange();
			});

			$keywords.on('keyup', debounce(function() {
				if (this.value === fields.keywords) return;
				searchModel.Fields.set('page', 1);
				searchModel.Fields.set('keywords', this.value);
				searchModel.Fields.set('orderBy', fields.keywords ? 'relevance' : 'latest');
				onFieldChange();
		    }, 300));

			// selects on change
		    $location.add($discipline).add($contractType)
		    	.on('change', function() {
		    		searchModel.Fields.set('page', 1);
					onFieldChange();
		    	});


		// replace state when going back

			function onPopState(event) {
				if (!event.state) {
					event.preventDefault();
					return false;
				}
				searchModel.Fields.replaceState(event.state);
				onFieldChange(true);
			}
			window.addEventListener('popstate', onPopState);


		// initial render

		onFieldChange(false);

		// UI tweaks
		// remove name= attribute to stop chrome autofilling data
		$keywords.attr('name', '');
	}


// fire after any field change events

	function onFieldChange(onPopState = false) {

		const isInitialLoad = searchModel.Fields.get(false).initialLoad;

		// only render loading when it's not an initial load, and isLoading is set
		!isInitialLoad && searchModel.Fields.set('isLoading', true) && renderLoading(searchModel.Fields.get(false));

		// change URL

			const currentPageNumber = parseInt(new URI().query(true).page) || 1;
			const nextPageNumber = searchModel.Fields.get().page;
			const nextURI = searchModel.buildSearchPageUrl();

			// don't change URL on popstates (back/forward navigation), just re-render

			if (!onPopState) {

				// first load, replace url with real search URL
				if (isInitialLoad) {
					window.history.replaceState && window.history.replaceState(searchModel.Fields.get(false), '', nextURI);
					searchModel.Fields.set('initialLoad', false);
				}

				// not first load, pushState if it's a pagination change
				if(!isInitialLoad && currentPageNumber !== nextPageNumber) {
					window.history.pushState && window.history.pushState(searchModel.Fields.get(), '', nextURI);
				}

				// if not a pagination change, just replace the state (so multiple searches don't cause 100 history entries)
				if (!isInitialLoad && currentPageNumber === nextPageNumber) {
					window.history.replaceState && window.history.replaceState(searchModel.Fields.get(), '', nextURI);
				}

				// if it's not the initial load, track it with analytics
				!isInitialLoad && window.gaTrackPageview && gaTrackPageview();
			}


		// get job data and render

		// TODO: on intial load, don't reload jobs
		// Requires dropping response data into <script> as JSON on the server side
		// Let's leave this for now — the API response / JS load is fast

			const APIUrl = searchModel.buildAPIUrl();

			// get jobs
			$.ajax({
		        url: APIUrl.toString(),
		        error : function(jqXHR, textStatus, errorThrown) {
		        	searchModel.Fields.set('response', false);
		        	searchModel.Fields.set('isLoading', false);
		        	render(searchModel.Fields.get(false));
		        },
		        success: function (response, status) {
		        	searchModel.Fields.set('response', response);
		        	searchModel.Fields.set('isLoading', false);
		        	render(searchModel.Fields.get(false));
		        }
		    });
	}


// render


	// main render function

	function render(fields) {

		renderLoading(fields);
		renderResultsHeader(fields);

		const apiResponse = fields.response;
		const showMap = (fields.map && fields.response && apiResponse.data && !jQuery.isEmptyObject(apiResponse.data));

		if (showMap) {
			searchMap.render(fields);
			renderResultsList(false);
			
		} else {
			renderResultsList(fields);
			searchMap.render(false);
		}

		renderPagination(fields);
	}


	function renderLoading(fields) {
		return fields.isLoading ? spinner.show() : spinner.hide();
	}


	function renderResultsHeader(fields) {

		const apiResponse = fields.response;
		const $resultsHeaderElem = $('.js-search-results-header');

		const formattedResultsHeader = (function formatResultsHeader(apiResponse) {

			var data = {};
			data.showingText = false;
			data.results = apiResponse.data || false;
			data.showing = {
				low : apiResponse.pagination && apiResponse.pagination.firstItemOnPage,
				high : apiResponse.pagination && apiResponse.pagination.lastItemOnPage,
				total: apiResponse.pagination && apiResponse.pagination.totalItems
			};
			 
			 if (apiResponse.pagination && apiResponse.pagination.totalItems === 0) {
			 	data.showing.low = 0;
			 }

			 data.map = fields.map;
			 return data;

		})(apiResponse);

		const resultsHeaderHTML = templateResultsHeader(formattedResultsHeader);
		$resultsHeaderElem.html(resultsHeaderHTML);

		// add interactivity

		$resultsHeaderElem.find('.js-view-map').on('click', function() {
			searchModel.Fields.set('map', 1);
			onFieldChange();
			return false;
		});

		$resultsHeaderElem.find('.js-view-list').on('click', function() {
			searchModel.Fields.set('map', 0);
			onFieldChange();
			return false;
		});
	}


	function renderResultsList(fields) {

		const apiResponse = fields.response;
		const $resultsListElem = $('.js-search-results-list');

		if (!fields) {
			$resultsListElem.empty();
			return false;
		}

		const formattedResultsList = (function formatResultsList(apiResponse) {
			var data = { results : apiResponse.data };
			return data;
		})(apiResponse);

		const resultsHTML = templateResultsList(formattedResultsList);
		$resultsListElem.html(resultsHTML);
	}


	function renderPagination(fields) {

		const apiResponse = fields.response;
		const $paginationElem = $('.js-search-pagination');

		function formatPagination(object, range = 2) {

			function pageHref(number) {
				var url = searchModel.buildSearchPageUrl();
				url.removeQuery('page');
				url.addQuery('page', number);
				return url.toString();
			}

			var showItems = range*2 + 1;
			var currentPage = object.currentPage || 1;
			var lastPage = object.lastPage || 1;

			var pagination = {
				nextPage : {
					href : pageHref(currentPage + 1),
					disabled : (currentPage < lastPage) ? false : true
				},
				previousPage : {
					href : (currentPage - 1 > 0) ? pageHref(currentPage - 1) : pageHref(1),
					disabled : (currentPage === 1) ? true : false
				},
				firstPage : {
					number : 1,
					href : pageHref(1),
					current : (currentPage === 1) ? true : false
				},
				lastPage : {
					number : lastPage,
					href : pageHref(lastPage),
					current : (currentPage === lastPage) ? true : false
				},
				numbers : []
			}

			if (pagination.firstPage.number === pagination.lastPage.number) {
				pagination.lastPage = false;
			}

			// ellipsis item 1
			if (currentPage > range + 2) {
				let page = {
					href : false,
					number : '…',
					current : false
				}
				pagination.numbers.push(page);
			}

			// inbetween first and main
			for (var i = 1; i <= lastPage; i++) {
				if (1 != lastPage &&( !(i >= currentPage+range+1 || i <= currentPage-range-1) || lastPage <= showItems )) {
					if (i === lastPage || i === 1) {
						continue;
					}
					let page = {
						number : i,
						href : pageHref(i),
						current : (currentPage === i) ? true : false
					}

					pagination.numbers.push(page);
				}
			}

			// ellipsis item 2
			if (currentPage < lastPage - range - 1) {
				let page = {
					href : false,
					number : '…',
					current : false
				}

				pagination.numbers.push(page);
			}

			return pagination;
		}

		const data = {
			pagination : formatPagination(apiResponse.pagination)
		};

		data.pagination = (apiResponse.data && apiResponse.data.length) ? data.pagination : false;
		data.pagination = (fields.map) ? false : data.pagination;

		const paginationHTML = templatePagination(data);
		$paginationElem.html(paginationHTML);

		// add events after render

		function paginationClickHandler(event) {

			event.preventDefault();

			var link = this.href;
			
			if (!this.href) return;

			const uri = new URI(this.href);
			const pageNumber = uri.query(true).page || 1;
			searchModel.Fields.set('page', pageNumber);

			scrollTo($('.js-search-form'), 3);
			onFieldChange();
			return false;
		}

		const $links = $paginationElem.find('a');
		$links.on('click', paginationClickHandler);
	}



export default {
	init
}